var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2312_154185",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2312_154185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.81818 20H14.1818C16.2184 20 17.2367 20 18.0145 19.6037C18.6987 19.255 19.255 18.6987 19.6037 18.0145C20 17.2367 20 16.2184 20 14.1818V9.81818C20 7.78163 20 6.76335 19.6037 5.98549C19.255 5.30126 18.6987 4.74497 18.0145 4.39634C17.2367 4 16.2184 4 14.1818 4H9.81818M9.81818 20C7.78163 20 6.76335 20 5.98549 19.6037C5.30126 19.255 4.74497 18.6987 4.39634 18.0145C4 17.2367 4 16.2184 4 14.1818V9.81818C4 7.78163 4 6.76335 4.39634 5.98549C4.74497 5.30126 5.30126 4.74497 5.98549 4.39634C6.76335 4 7.78163 4 9.81818 4M9.81818 20V4",
    stroke: "#162C38",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9L13 12L16 15",
    stroke: "#162C38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHide);
export default __webpack_public_path__ + "static/media/sidebar-hide.69b40788d9c9634b46e9c4d78a7d6c18.svg";
export { ForwardRef as ReactComponent };